import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderCard.vue?vue&type=template&id=38c0ae68&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderCard.vue?vue&type=style&index=0&id=38c0ae68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0ae68",
  null
  
)

export default component.exports